import Page from "../../../../modules/Core/Components/Page";
import templateDefault from "../../../templates/default/pages/world/legacy";

export default class Legacy extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Legacy")} | ${this.ucfirst("window-title")}`
    );
  }
}
